export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vérification avant envoi"])},
        "hint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le client recevra ce message par email et sera invité à compléter uniquement ces éléments de sa déclaration."])},
        "edit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifier"])},
        "confirm": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize(["Confirmer l'envoi"]), _normalize(["Confirmer l'envoi (1 demande)"]), _normalize(["Confirmer l'envoi (", _interpolate(_named("count")), " demandes)"])])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Review before sending"])},
        "hint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The customer will receive this message by email and will only be asked to complete these items of their declaration."])},
        "edit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit"])},
        "confirm": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize(["Confirm sending"]), _normalize(["Confirm sending (1 request)"]), _normalize(["Confirm sending (", _interpolate(_named("count")), " requests)"])])}
      }
    }
  })
}
